import EmblaCarousel from 'embla-carousel'
import EmblaCarouselFade from 'embla-carousel-fade'

const carouselInstances = new WeakMap()

document.querySelectorAll('.media-carousel-container .media-carousel').forEach(initCarousel)
document.querySelectorAll('.floorplans-panels .carousel-container').forEach(initFloorplanCarousel)

function initCarousel(carouselEl) {
  if (carouselInstances.has(carouselEl)) {
    carouselInstances.get(carouselEl).main.reInit()
    return
  }

  const container = carouselEl.closest('.carousel-container')
  const prevBtn = container.querySelector('.carousel-previous')
  const nextBtn = container.querySelector('.carousel-next')

  const embla = EmblaCarousel(carouselEl, {
    loop: true,
    align: 'center',
    containScroll: false,
    dragFree: false,
    slidesToScroll: 1,
  })

  embla.on('init', () => {
    prevBtn?.addEventListener('click', () => embla.scrollPrev())
    nextBtn?.addEventListener('click', () => embla.scrollNext())
  })

  const dotsEl = container.querySelector('.carousel-pagination')
  if (dotsEl) {
    const buildDots = () => {
      dotsEl.innerHTML = embla
        .scrollSnapList()
        .map(
          (_, i) =>
            `<button class="carousel-dot${i === embla.selectedScrollSnap() ? ' is-selected' : ''}" data-index="${i}"></button>`,
        )
        .join('')
      dotsEl.querySelectorAll('.carousel-dot').forEach((dot) => {
        dot.addEventListener('click', () => embla.scrollTo(Number(dot.dataset.index)))
      })
    }
    const syncDots = () => {
      dotsEl.querySelectorAll('.carousel-dot').forEach((dot, i) => {
        dot.classList.toggle('is-selected', i === embla.selectedScrollSnap())
      })
    }
    embla.on('init', buildDots)
    embla.on('reInit', buildDots)
    embla.on('select', syncDots)
  }

  const thumbsEl = container.querySelector('.carousel-thumbs')
  let emblaThumb = null
  if (thumbsEl) {
    emblaThumb = EmblaCarousel(thumbsEl, {
      loop: true,
      containScroll: 'keepSnaps',
      dragFree: true,
      align: 'center',
    })

    const syncThumbsActive = () => {
      const selected = embla.selectedScrollSnap()
      thumbsEl.querySelectorAll('.carousel-thumb').forEach((thumb, i) => {
        thumb.classList.toggle('is-selected', i === selected)
      })
      emblaThumb.scrollTo(selected)
    }

    thumbsEl.querySelectorAll('.carousel-thumb').forEach((thumb, i) => {
      thumb.addEventListener('click', () => embla.scrollTo(i))
    })

    embla.on('init', syncThumbsActive)
    embla.on('reInit', syncThumbsActive)
    embla.on('select', syncThumbsActive)
  }

  carouselInstances.set(carouselEl, {main: embla, thumb: emblaThumb})
}

document.querySelectorAll('.carousel-container .swiper').forEach(initMapCarousel)

function initMapCarousel(swiperEl) {
  const container = swiperEl.closest('.carousel-container')
  const prevBtn = container.querySelector('.carousel-previous')
  const nextBtn = container.querySelector('.carousel-next')

  const swiper = new Swiper(swiperEl, {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: true,
    allowTouchMove: true,
  })

  prevBtn?.addEventListener('click', () => swiper.slidePrev())
  nextBtn?.addEventListener('click', () => swiper.slideNext())
}

function initFloorplanCarousel(container) {
  const carouselEl = container.querySelector('.floorplans-carousel')
  if (!carouselEl) return

  if (carouselInstances.has(carouselEl)) {
    carouselInstances.get(carouselEl).main.reInit()
    return
  }

  const prevBtn = container.querySelector('.carousel-previous')
  const nextBtn = container.querySelector('.carousel-next')

  // Wrap each slide in an embla-compatible slide div
  const slidesContainer = carouselEl.querySelector('.floorplans-carousel__slides')
  if (!slidesContainer) return

  // Re-wrap: move slidesContainer into a proper embla viewport > container structure
  const slideEls = Array.from(carouselEl.querySelectorAll('.floorplans-carousel__slides'))

  // Build embla structure: carouselEl becomes the viewport, wrap slides in a container
  const emblaContainer = document.createElement('div')
  emblaContainer.classList.add('floorplans-embla__container')

  slideEls.forEach((slide) => {
    const wrapper = document.createElement('div')
    wrapper.classList.add('floorplans-embla__slide')
    slide.parentNode.insertBefore(wrapper, slide)
    wrapper.appendChild(slide)
    emblaContainer.appendChild(wrapper)
  })

  carouselEl.appendChild(emblaContainer)

  const embla = EmblaCarousel(carouselEl, {loop: true}, [EmblaCarouselFade()])

  embla.on('init', () => {
    prevBtn?.addEventListener('click', () => embla.scrollPrev())
    nextBtn?.addEventListener('click', () => embla.scrollNext())
  })

  carouselInstances.set(carouselEl, {main: embla, thumb: null})
}

export function onFloorPanelActivated(panelEl) {
  panelEl.querySelectorAll('.media-carousel').forEach(initCarousel)
  panelEl.querySelectorAll('.carousel-container').forEach(initFloorplanCarousel)
}

// Floorplan tab switching
$('.floorplans-container [data-target]').on('click', function () {
  const target = $(this).data('target')
  const $container = $(this).closest('.floorplans-container')

  $container.find('[data-target]').removeClass('active')
  $(this).addClass('active')

  $container.find('[data-floorplan]').removeClass('is-active')
  const $panel = $container.find(`[data-floorplan="${target}"]`).addClass('is-active')

  onFloorPanelActivated($panel[0])
})

requestAnimationFrame(() => {
  document
    .querySelectorAll('.floorplans-panels [data-floorplan].is-active')
    .forEach(onFloorPanelActivated)
})
